import { FaExclamationCircle } from 'react-icons/fa';

const BLOCK = 'LStudio__app_field';

/*
    🔥 LA CÁSCARA DE CUALQUIER CAMPO

    Label, obligatorio, ayuda, error y el hueco donde va el control.
    Es el equivalente de ToastBody: la estética vive acá una sola vez.

    Cualquier campo nuevo — incluidos los de librería, como react-select
    o el datepicker — se envuelve con esto y queda consistente sin
    volver a escribir un label ni un mensaje de error.
*/

export const FieldShell = ({
    id,
    label,
    hint,
    error,
    isRequired = false,
    isDisabled = false,
    layout = 'stack',       // stack | inline (para checkbox y switch)
    span = 1,               // columnas que ocupa en la grilla
    children,
}) => (

    <div className={`${BLOCK} ${BLOCK}--${layout}`}
        data-error={!!error} data-disabled={isDisabled} style={{ '--LS__field_span': span }} >

        {
            label && (
                <label className={`${BLOCK}__label`} htmlFor={id}>
                    {label}
                    {isRequired && <span className={`${BLOCK}__required`} aria-hidden="true">*</span>}
                </label>
            )
        }

        <div className={`${BLOCK}__control`}>{children}</div>

        {
            error
                ? (
                    <p className={`${BLOCK}__error`} role="alert">
                        <FaExclamationCircle aria-hidden="true" />
                        {error}
                    </p>
                )
                : hint && <p className={`${BLOCK}__hint`}>{hint}</p>
        }

    </div>
);
